// import { getChooseTravelerProperties } from "@checkout/states/Products/Flight/selectors";
import { CHOOSE_TRAVELER } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackChooseTraveler = async (context) =>
  trackBaseEvent(context, {
    eventName: CHOOSE_TRAVELER,
    properties: {},
  });
